import NewTransferReturn from "../../../../components/@documents/transfer_returns/NewTransferReturn";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function TransferReturnNewPage() {

    return (
        <NewTransferReturn 
            routeType={routeTypes.admin}
        />
    )
}